/*
  Delayed third-party scripts
  Loads non-essential scripts after page load + first interaction fallback.
*/

(function () {
  var delayedScriptsLoaded = false;
  var upstackifiedIntentListenersAdded = false;

  function loadExternalScript(src, options) {
    options = options || {};

    var existingScript = document.querySelector('script[src="' + src + '"]');

    if (existingScript) {
      if (typeof options.onload === 'function') {
        if (existingScript.dataset.loaded === 'true') {
          options.onload();
        } else {
          existingScript.addEventListener('load', options.onload, { once: true });
        }
      }

      return existingScript;
    }

    var script = document.createElement('script');
    script.src = src;
    script.async = options.async !== false;

    if (options.id) {
      script.id = options.id;
    }

    if (typeof options.onload === 'function') {
      script.onload = function () {
        script.dataset.loaded = 'true';
        options.onload();
      };
    }

    document.body.appendChild(script);
    return script;
  }

  function loadClarity() {
    try {
      if (window.__clarityDelayedLoaded) return;
      window.__clarityDelayedLoaded = true;

      (function (c, l, a, r, i, t, y) {
        c[a] = c[a] || function () {
          (c[a].q = c[a].q || []).push(arguments);
        };

        t = l.createElement(r);
        t.async = 1;
        t.src = "https://www.clarity.ms/tag/" + i + "?ref=shopify";

        y = l.getElementsByTagName(r)[0];
        y.parentNode.insertBefore(t, y);

        if (c.Shopify && c.Shopify.loadFeatures) {
          c.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function (error) {
            if (error) return;

            c[a]('consentv2', {
              ad_Storage: c.Shopify.customerPrivacy.marketingAllowed() ? "granted" : "denied",
              analytics_Storage: c.Shopify.customerPrivacy.analyticsProcessingAllowed() ? "granted" : "denied",
              source: 101
            });
          });
        }

        l.addEventListener("visitorConsentCollected", function (e) {
          c[a]('consentv2', {
            ad_Storage: e.detail.marketingAllowed ? "granted" : "denied",
            analytics_Storage: e.detail.analyticsAllowed ? "granted" : "denied",
            source: 101
          });
        });
      })(window, document, "clarity", "script", "a8qw3rc9pp");
    } catch (e) {
      console.error('Clarity delayed load error:', e);
    }
  }

  function setupKlaviyoQueue() {
    try {
      if (!window.klaviyo) {
        window._klOnsite = window._klOnsite || [];

        try {
          window.klaviyo = new Proxy({}, {
            get: function (n, i) {
              return i === "push"
                ? function () {
                    var n;
                    (n = window._klOnsite).push.apply(n, arguments);
                  }
                : function () {
                    var n = arguments.length;
                    var o = new Array(n);
                    var w = 0;

                    for (; w < n; w++) {
                      o[w] = arguments[w];
                    }

                    var t = typeof o[o.length - 1] === "function" ? o.pop() : void 0;

                    var e = new Promise(function (n) {
                      window._klOnsite.push([i].concat(o, [function (i) {
                        if (t) t(i);
                        n(i);
                      }]));
                    });

                    return e;
                  };
            }
          });
        } catch (n) {
          window.klaviyo = window.klaviyo || [];
          window.klaviyo.push = function () {
            var n;
            (n = window._klOnsite).push.apply(n, arguments);
          };
        }
      }

      window.klaviyoReviewsProductDesignMode = false;
    } catch (e) {
      console.error('Klaviyo queue setup error:', e);
    }
  }

  function loadKlaviyo() {
    try {
      if (window.__klaviyoDelayedLoaded) return;
      window.__klaviyoDelayedLoaded = true;

      loadExternalScript('https://static.klaviyo.com/onsite/js/KZsJjc/klaviyo.js?company_id=KZsJjc');
    } catch (e) {
      console.error('Klaviyo delayed load error:', e);
    }
  }

  function loadOctane() {
    try {
      if (window.__octaneDelayedLoaded) return;

      /*
        Only load Octane AI on:
        - /pages/gift-finder
      */
      var allowedOctanePaths = ['/pages/gift-finder'];
      var currentPath = window.location.pathname.replace(/\/$/, '') || '/';

      if (allowedOctanePaths.indexOf(currentPath) === -1) {
        return;
      }

      window.__octaneDelayedLoaded = true;

      var urls = [
        'https://app.octaneai.com/xr261s3vbwgamjl6/shopify.js?x=klEssNBWtqszXB5t&shop=estella-nyc-2.myshopify.com'];

      urls.forEach(function (src) {
        loadExternalScript(src);
      });
    } catch (e) {
      console.error('Octane delayed load error:', e);
    }
  }

  function removeUpstackifiedIntentListeners() {
    if (!upstackifiedIntentListenersAdded) return;

    window.removeEventListener('click', loadUpstackifiedFromIntent);
    window.removeEventListener('touchstart', loadUpstackifiedFromIntent);
    window.removeEventListener('keydown', loadUpstackifiedFromIntent);
    window.removeEventListener('submit', loadUpstackifiedFromIntent, true);

    upstackifiedIntentListenersAdded = false;
  }

  function loadUpstackifiedFromIntent() {
    removeUpstackifiedIntentListeners();

    /*
      Small extra delay after intent so it does not compete directly
      with the interaction/click that triggered it.
    */
    setTimeout(loadUpstackified, 1200);
  }

  function setupUpstackifiedQueue() {
    try {
      /*
        Pixel ID from the original Upstackified app block.
        Keep this in place so the delayed script has the account/pixel details it expects.
      */
      window._adtrPixelDetails = window._adtrPixelDetails || 'da480ae8-674b-4aaf-939c-463d8289f8b8';

      /*
        Set up queue/stubs before loading the external script.
        This lets any early Upstackified calls queue safely until the script is ready.
      */
      window._upsLoaded = window._upsLoaded || 0;
      window._upssqueue = window._upssqueue || [];

      window._upstack = window._upstack || function () {
        window._upssqueue.push(arguments);
      };

      window._upssClient = window._upssClient || function () {
        window._upssqueue.push(arguments);
      };
    } catch (e) {
      console.error('Upstackified queue setup error:', e);
    }
  }

  function loadUpstackified() {
    try {
      if (window.__upstackifiedDelayedLoaded) return;
      window.__upstackifiedDelayedLoaded = true;

      removeUpstackifiedIntentListeners();
      setupUpstackifiedQueue();

      var upstackifiedSrc = 'https://prod2-cdn.upstackified.com/scripts/px/adtr-shopify.min.js';
      var existingScript = document.querySelector('script[src*="prod2-cdn.upstackified.com/scripts/px/adtr-shopify.min.js"]');

      if (existingScript) {
        return;
      }

      loadExternalScript(upstackifiedSrc, {
        id: 'delayed-upstackified-pixel',
        async: true,
        onload: function () {
          try {
            if (typeof window._upssClient === 'function') {
              window._upssClient('init');
            }
          } catch (e) {
            console.error('Upstackified init error:', e);
          }
        }
      });
    } catch (e) {
      console.error('Upstackified delayed load error:', e);
    }
  }

  function setupUpstackifiedDeepDelay() {
    if (upstackifiedIntentListenersAdded || window.__upstackifiedDelayedLoaded) return;

    setupUpstackifiedQueue();

    upstackifiedIntentListenersAdded = true;

    /*
      Do NOT load Upstackified on basic scroll/mousemove.
      Those are too easy for PSI/Lighthouse or passive users to trigger.

      Load it only on stronger intent:
      - click
      - touchstart
      - keyboard interaction
      - form submit / checkout-like intent

      Then use a long fallback so it still eventually loads for attribution,
      but usually outside the PSI scoring window.
    */
    window.addEventListener('click', loadUpstackifiedFromIntent, { once: true, passive: true });
    window.addEventListener('touchstart', loadUpstackifiedFromIntent, { once: true, passive: true });
    window.addEventListener('keydown', loadUpstackifiedFromIntent, { once: true });
    window.addEventListener('submit', loadUpstackifiedFromIntent, true);

    /*
      Long fallback. This is the part that should make the PSI impact much smaller.
      Increase to 45000 or 60000 if you want to be more aggressive.
    */
    setTimeout(loadUpstackified, 30000);
  }

  function loadDelayedScripts() {
    if (delayedScriptsLoaded) return;
    delayedScriptsLoaded = true;

    window.removeEventListener('scroll', loadDelayedScripts);
    window.removeEventListener('mousemove', loadDelayedScripts);
    window.removeEventListener('touchstart', loadDelayedScripts);
    window.removeEventListener('keydown', loadDelayedScripts);

    /*
      Staggering prevents all third-party scripts from competing
      for the main thread at the exact same moment.
    */
    setTimeout(loadClarity, 500);
    setTimeout(loadKlaviyo, 1200);
    setTimeout(loadOctane, 2200);

    /*
      Important:
      Upstackified is intentionally NOT loaded in this main delayed batch anymore.
      It is handled separately by setupUpstackifiedDeepDelay().
    */
  }

  setupKlaviyoQueue();
  setupUpstackifiedQueue();

  window.addEventListener('load', function () {
    setTimeout(loadDelayedScripts, 4000);

    /*
      Start the Upstackified delay logic after full page load,
      but don't actually load the external script unless stronger intent happens
      or the long fallback timer completes.
    */
    setupUpstackifiedDeepDelay();
  });

  window.addEventListener('scroll', loadDelayedScripts, { once: true, passive: true });
  window.addEventListener('mousemove', loadDelayedScripts, { once: true });
  window.addEventListener('touchstart', loadDelayedScripts, { once: true, passive: true });
  window.addEventListener('keydown', loadDelayedScripts, { once: true });
})();